import classification from '../../../images/ai factory icons/classification.png';
import posedetections from '../../../images/ai factory icons/posedetection.png';
import troubleshooting from '../../../images/ai factory icons/troubleshooting.png';
import deviceaugmentation from '../../../images/ai factory icons/deviceaugmentation.png';
import textanalysis from '../../../images/ai factory icons/textanalysis.png';
import analyzeflow from '../../../images/ai factory icons/analyzeflow.png';
import segmenthor from '../../../images/ai factory icons/segmenthor.png';
import qatool from '../../../images/ai factory icons/qatool.png';
import preprocess from '../../../images/ai factory icons/preprocess.png';
import train from '../../../images/ai factory icons/train.png';
import synthetictool from '../../../images/ai factory icons/synthetictool.png';
import singleimageannotationtool from '../../../images/ai factory icons/singleimageannotationtool.png';

export const factoryItems = [{
    title: 'Model Builder',
    factoryBoxes: [{
        src: classification,
        title: 'Unboxing',
        authenticationKey: 'rest',
    }, {
        src: posedetections,
        title: 'Classification',
        authenticationKey: 'classification',
    }, {
        src: troubleshooting,
        title: 'Troubleshooting',
        authenticationKey: 'management',
    }, {
        src: deviceaugmentation,
        title: 'Device Augmentation',
        authenticationKey: 'rest',
    }, {
        src: textanalysis,
        title: 'Text Analysis',
        authenticationKey: 'rest',
    }, {
        src: analyzeflow,
        title: 'Analyze Flow',
        authenticationKey: 'rest',
    }]
}, {
    title: 'AIFactory Toolbox',
    factoryBoxes: [{
        src: segmenthor,
        title: 'Annotation Factory',
        authenticationKey: 'rest',
    }, {
        src: qatool,
        title: 'Configuration',
        authenticationKey: 'configurationPage',
    }, {
        src: preprocess,
        title: 'Data Pre Processing',
        authenticationKey: 'rest',
    }, {
        src: train,
        title: 'Model Training',
        authenticationKey: 'rest',
    }, {
        src: synthetictool,
        title: 'Synthetic Tool',
        authenticationKey: 'rest',
    }, {
        src: singleimageannotationtool,
        title: 'Tagging Platform',
        authenticationKey: 'tagging',
    }]
}];
